<template>
    <div class="fill-height">
        <TabBasic show-breadcrumbs>
            <template v-slot:header>
                <v-spacer/>
            </template>
            <div>
                <TabBasic toolbar-color="primary" toolbar-text-color="secondary--text">
                    <template v-slot:header>
                        {{ $t('account.myProfile') }}
                    </template>
                    <v-form
                            ref="profileForm"
                            v-model="validProfile"
                            @submit.prevent="saveProfile">
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-row>
                                    <v-col class="pb-0" cols="12">
                                        <v-text-field
                                                ref="test"
                                                v-model="user.FirstName"
                                                :rules="[$validations.required]"
                                                class="mb-2"
                                                required>
                                            <template v-slot:label>
                                                {{ $t('authentication.firstName') }}<sup>*</sup>
                                            </template>
                                        </v-text-field>
                                        <v-text-field
                                                v-model="user.LastName"
                                                :rules="[$validations.required]"
                                                class="mb-2"
                                                required>
                                            <template v-slot:label>
                                                {{ $t('authentication.lastName') }}<sup>*</sup>
                                            </template>
                                        </v-text-field>
                                        <v-text-field
                                                v-model="user.Email"
                                                :rules="[$validations.required]"
                                                class="mb-2"
                                                disabled
                                                readonly
                                                required>
                                            <template v-slot:label>
                                                {{ $t('authentication.email') }}<sup>*</sup>
                                            </template>
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <input ref="file" hidden type="file" @change="uploadFile"/>
                            <v-col class="pb-8 pb-md-0 justify-center d-flex" cols="12" md="6">
                                <v-menu absolute bottom left>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-avatar class="pointer" size="200" v-bind="attrs"
                                                  v-on="on">
                                            <img
                                                    v-if="user.AvatarUrl"
                                                    :src="user.AvatarUrl"
                                                    alt="avatar">
                                            <v-icon v-else size="200">
                                                mdi-account-circle
                                            </v-icon>
                                        </v-avatar>
                                    </template>
                                    <v-list class="px-2" tile>
                                        <v-list-item
                                                link
                                                @click="$refs.file.click()">
                                            <v-list-item-title>{{ $t('account.changeAvatar') }}</v-list-item-title>
                                        </v-list-item>
                                        <v-list-item
                                                v-if="user.AvatarUrl"
                                                link
                                                @click="removeAvatar">
                                            <v-list-item-title>{{ $t('account.removeAvatar') }}</v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                            </v-col>
                        </v-row>
                        <v-row class="my-0">
                            <v-col cols="12" md="6">
                                <v-text-field
                                        v-model="user.Address"
                                        class="mb-2"
                                        required>
                                    <template v-slot:label>
                                        {{ $t('authentication.address') }}
                                    </template>
                                </v-text-field>
                                <MazPhoneNumberInput ref="phoneNumber"
                                                     v-model="phoneNumber"
                                                     :border-radius="0"
                                                     :clear="false"
                                                     :dark="isDark"
                                                     :default-country-code="countryCode"
                                                     :default-phone-number="user.PhoneNumber"
                                                     :error="errorPhone"
                                                     :error-color="$vuetify.theme.currentTheme.error"
                                                     :valid-color="$vuetify.theme.currentTheme.primary"
                                                     class="phone-number"
                                                     color="white"
                                                     show-code-on-list
                                                     @update="updatePhone">
                                    <template v-if="phoneNumber && phoneNumber === oldUser.PhoneNumber "
                                              v-slot:icon-right>
                                        <template v-if="user.PhoneNumberConfirmed">
                                            <v-icon color="success">mdi-checkbox-marked-circle</v-icon>
                                            <span class="body-1 ml-2">{{ $t('account.confirmed') }}</span>
                                        </template>
                                        <v-btn v-else :loading="loadingConfirm" @click="confirmPhoneNumber">Confirm
                                            phone number
                                        </v-btn>
                                    </template>
                                </MazPhoneNumberInput>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-select
                                        v-model="theme"
                                        :items="themes"
                                        :label="$t('account.theme')"
                                ></v-select>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col class="text-right">
                                <v-btn
                                        :disabled="!hasChangesProfile && !themeChanged"
                                        class="elevation-5  secondary--text mr-3"
                                        color="primary"
                                        large
                                        @click="resetProfileForm">
                                    {{ $t('cancel') }}
                                </v-btn>
                                <v-btn
                                        ref="saveProfile"
                                        :disabled="!hasChangesProfile && !themeChanged"
                                        :loading="loadingProfile"
                                        class="elevation-5 accentText--text"
                                        color="accent"
                                        large
                                        @click="saveProfile">
                                    {{ $t('save') }}
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-form>
                </TabBasic>
            </div>
            <div class="mt-5">
                <TabBasic toolbar-color="primary" toolbar-text-color="secondary--text">
                    <template v-slot:header>
                        {{ $t('account.changePassword') }}
                    </template>
                    <v-form
                            ref="passwordForm"
                            v-model="validPassword">
                        <v-row>
                            <v-col cols="6">
                                <v-row>
                                    <v-col cols="12">
                                        <v-text-field
                                                v-model="password.oldPassword"
                                                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                                :rules="[$validations.required]"
                                                :type="showPassword ? 'text' : 'password'"
                                                class="mb-2"
                                                required
                                                @keyup.enter="savePassword"
                                                @click:append="showPassword = !showPassword">
                                            <template v-slot:label>
                                                {{ $t('account.oldPassword') }}<sup>*</sup>
                                            </template>
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="mt-0 mb-0">
                            <v-col class="py-0" cols="6">
                                <v-text-field
                                        v-model="password.newPassword"
                                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                        :rules="[$validations.required, $validations.password]"
                                        :type="showPassword ? 'text' : 'password'"
                                        class="mb-2"
                                        required
                                        @keyup.enter="savePassword"
                                        @click:append="showPassword = !showPassword">
                                    <template v-slot:label>
                                        {{ $t('account.newPassword') }}<sup>*</sup>
                                    </template>
                                </v-text-field>
                            </v-col>
                            <v-col class="py-0" cols="6">
                                <v-text-field
                                        v-model="password.confirmNewPassword"
                                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                        :rules="[$validations.required, $validations.password, passwordConfirmationRule]"
                                        :type="showPassword ? 'text' : 'password'"
                                        class="mb-2"
                                        required
                                        @keyup.enter="savePassword"
                                        @click:append="showPassword = !showPassword">
                                    <template v-slot:label>
                                        {{ $t('account.confirmNewPassword') }}<sup>*</sup>
                                    </template>
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="mt-0">
                            <v-col class="text-right">
                                <v-btn
                                        :disabled="!hasChangesPassword"
                                        class="elevation-5  secondary--text mr-3"
                                        color="primary"
                                        large
                                        @click="resetPasswordForm">
                                    {{ $t('cancel') }}
                                </v-btn>
                                <v-btn
                                        :disabled="!hasChangesPassword"
                                        :loading="loadingPassword"
                                        class="elevation-5  accentText--text"
                                        color="accent"
                                        large
                                        @click="savePassword">
                                    {{ $t('save') }}
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-form>
                </TabBasic>
            </div>
        </TabBasic>
        <DeleteDialog ref="deleteDialog" :delete-title="deleteActionTitle" :title="deleteTitle"/>
        <LeaveConfirmDialog ref="leaveConfirmDialog"/>
        <PhoneConfirmationDialog :open="openDialogPhoneConfirmation" @close="openDialogPhoneConfirmation=false"
                                 @confirmed="initUser"/>
    </div>
</template>

<script>
import TabBasic from "@/components/reusable/TabBasic/TabBasic";
import {isEqual} from "@/helper/helper";
import DeleteDialog from "@/components/reusable/Dialog/DeleteDialog";
import PhoneConfirmationDialog from "@/components/reusable/Dialog/PhoneConfirmationDialog";

export default {
  name: "MyAccount",
  components: {PhoneConfirmationDialog, DeleteDialog, TabBasic},
  mounted() {
    this.initUser();
  },
  data() {
    return {
      validProfile: true,
      validPassword: false,
      phoneNumber: '',
      deleteTitle: '',
      deleteActionTitle: '',
      user: {
        firstName: '',
        lastName: '',
        AvatarUrl: '',
        Avatar: '',
        theme: '',
      },
      oldUser: {
        theme: '',
      },
      password: {
        oldPassword: '',
        newPassword: '',
        confirmNewPassword: ''
      },
      theme: this.$store.getters.getTheme,
      showPassword: false,
      loadingConfirm: false,
      loadingPassword: false,
      loadingProfile: false,
      loadingSubscription: false,
      hasChangesProfile: false,
      hasChangesPassword: false,
      errorPhone: false,
      selectedOrganization: this.$store.getters.getOrganizationId,
      isAdmin: this.$store.getters.isOrganizationAdmin,
      openDialogNewSubscription: false,
      openDialogPhoneConfirmation: false,
      countryCode: this.$store.getters.getUserCountry,
    };
  },
  watch: {
    user: {
      handler() {
        this.hasChangesProfile = !isEqual({...this.user, PhoneNumber: this.phoneNumber}, this.oldUser);
      },
      deep: true,
    },
    password: {
      handler() {
        this.hasChangesPassword = this.password.newPassword.length || this.password.confirmNewPassword.length || this.password.oldPassword.length;
      },
      deep: true,
    },
    organizationID() {
      this.selectedOrganization = this.organizationID;
    },
    userCountry(val) {
      if (this.user && !this.user.PhoneNumber) {
        this.countryCode = val;
      }
    }
  },
  computed: {
    userCountry() {
      return this.$store.getters.getUserCountry;
    },
    userID() {
      return this.$store.getters.getUserId;
    },
    organizations() {
      return this.$store.getters.getOrganizations;
    },
    isDark() {
      return this.$store.getters.getTheme === 'dark';
    },
    themeChanged() {
      return this.$store.getters.getTheme !== this.theme;
    },
    themes() {
      return [
        {
          value: 'light',
          text: this.$t('account.light')
        },
        {
          value: 'dark',
          text: this.$t('account.dark')
        },
      ];
    },
    passwordConfirmationRule() {
      return () => (this.password.newPassword === this.password.confirmNewPassword) || this.$t('errors.passwordsNotMatch');
    },
    organizationID() {
      return this.$store.getters.getOrganizationId;
    }
  },
  methods: {
    initUser() {
      const url = this.$store.getters.account(this.$store.getters.getUserId);
      this.axios.get(url).then(({data}) => {
        this.user = {...data.Result};
        this.oldUser = {...data.Result};
        if (this.user.AvatarUrl) {
          this.user.AvatarUrl += '?t=' + new Date().getTime();
          this.oldUser.AvatarUrl += '?t=' + new Date().getTime();
        }

        if (this.user.PhoneNumber) {
          this.countryCode = '';
        }
      });
    },
    resetProfileForm() {
      this.user = {...this.oldUser};
      this.theme = this.$store.getters.getTheme;
    },
    resetPasswordForm() {
      this.$refs.passwordForm.reset();
      this.hasChangesPassword = false;
    },
    saveProfile() {
      this.$refs.test.focus();
      this.$refs.test.blur();
      this.$refs.profileForm.validate();
      if (!this.validProfile || this.errorPhone) {
        return;
      }

      if (this.themeChanged) {
        this.$store.dispatch('setTheme', this.theme);
        this.$vuetify.theme.dark = this.theme === 'dark';
      }

      if (this.hasChangesProfile) {
        const url = this.$store.getters.account(this.$store.getters.getUserId);
        this.loadingProfile = true;
        this.axios.patch(url, {...this.user, PhoneNumber: this.phoneNumber}, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }).then(() => {
          this.$store.dispatch('addNotification',
              {
                type: 'success',
                message: this.$t('success.profileWasUpdated')
              });
          if (this.user.AvatarUrl !== this.oldUser.AvatarUrl) {
            this.$store.dispatch('refreshToken');
          }
          this.initUser();
          this.hasChangesProfile = false;
        }).finally(() => {
          this.loadingProfile = false;
        });
      }
    },
    savePassword() {
      this.$refs.passwordForm.validate();
      if (!this.validPassword) {
        return;
      }
      const url = this.$store.getters.accountPassword(this.$store.getters.getUserId);
      this.loadingPassword = true;
      this.axios.patch(url, this.password).then(() => {
        this.$store.dispatch('addNotification',
            {
              type: 'success',
              message: this.$t('success.passwordWasChanged')
            });
        this.$refs.passwordForm.reset();
        this.hasChangesPassword = false;
      }).finally(() => {
        this.loadingPassword = false;
      });
    },
    updatePhone(val) {
      if (val.phoneNumber) {
        this.errorPhone = !val.isValid;
        this.user.PhoneNumber = val.e164;
        this.user.PhoneNumber = val.nationalNumber;

      } else {
        this.errorPhone = false;
        this.user.PhoneNumber = null;
      }
    },
    removeAvatar() {
      this.user.Avatar = null;
      this.user.AvatarUrl = '';
    },
    uploadFile(files) {
      const [file] = files.target.files;
      if (file) {
        this.user.AvatarUrl = URL.createObjectURL(file);
        this.user.Avatar = file;
      }
    },
    leaveOrganization() {
      this.deleteActionTitle = this.isAdmin ? this.$t('remove') : this.$t('leave');
      this.deleteTitle = this.isAdmin ? this.$t('account.areYouSureRemoveOrganization') : this.$t('account.areYouSureLeaveOrganization');
      this.$refs.deleteDialog.openDialog().then((result) => {
        if (result) {
          let url = this.$store.getters.organization(this.selectedOrganization);
          this.axios.delete(url).then(() => {
            this.$store.dispatch('refreshOrganizations');
            if (this.organizationID === this.selectedOrganization) {

              this.$store.dispatch('setOrganizationId', null);
            }
          });
        }
      });
    },
    selectOrganization() {
      this.$store.dispatch('setOrganizationId', this.selectedOrganization);
    },
    createNewSubscription() {
      this.openDialogNewSubscription = true;
    },
    closeDialog(refreshOrganization = false) {
      this.openDialogNewSubscription = false;
      if (refreshOrganization) {
        this.$store.dispatch('refreshOrganizations');
      }
    },
    confirmPhoneNumber() {
      const url = this.$store.getters.getUrl('requestConfirmPhoneNumber');
      this.axios.post(url).then(() => {
        this.$store.dispatch('addNotification',
            {
              type: 'success',
              message: this.$t('success.confirmTokenSent')
            });
        this.openDialogPhoneConfirmation = true;
      });
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.hasChangesPassword || this.hasChangesProfile) {
      this.$refs.leaveConfirmDialog.openDialog().then((res) => {
        if (res) {
          next();
        }
        this.next = next;
        next(false);
      });

    } else {
      return next();
    }
  },
};
</script>

<style lang="scss" scoped>
@import "my-account";
</style>